import axios from 'axios'
import Swal from 'sweetalert2'
import authService from '../../api/api-authorization/AuthorizeService'
import { ApplicationPaths } from '../../api/api-authorization/ApiAuthorizationConstants'

export default async function Axios(endpoint, json, callback, isNotValid) {
    // Always fetch (or return cached) token before the request so the Bearer
    // header is present even when components mount before AuthContext's request
    // interceptor has had a chance to install itself.
    const token = await authService.getAccessToken();
    const headers = token ? { Authorization: `Bearer ${token}` } : {};

    axios.post(`${endpoint}`, json, { headers })
        .then((res) => {
            if (res.data.status || res.status) {
                if (callback) {

                    switch (res.data.source ? res.data.source : '') {
                        case "workflow":
                            callback(res.data.data)
                            break;
                        case "myworkflow":
                            callback(res.data)
                            break;
                        case "workflowstatus":
                            callback(res.data)
                            break;
                        case "workflowdetail":
                            callback(res.data)
                            break;
                        default:
                            callback(res.data.data === undefined ? res.data : res.data.data)
                    }
                }
            }
            else {
                if (isNotValid) {
                    isNotValid(res)
                }
            }
        })
        .catch((error) => {
            console.error(error);
        });
}

// Add a 401 response interceptor
//axios.interceptors.response.use(function (response) {
//    return response;
//}, function (error) {
//        if (401 === error.response.status
//            && error.response.headers["www-authenticate"] ===
//            'Bearer error="invalid_token", error_description="The token expired"') {
//        Swal.fire({
//            title: "Session Expired",
//            text: "Your session has expired. Would you like to be redirected to the login page?",
//            type: "warning",
//            showCancelButton: true,
//            confirmButtonColor: "#5052bb",
//            confirmButtonText: "Yes",
//            closeOnConfirm: true
//        }).then(async function () {
//            window.location.href = '/authentication/logout';
//        });;
//    } else {
//        return Promise.reject(error);
//    }
//});

axios.interceptors.response.use(function (response) {
    return response;
}, function (error) {
    if (401 === error.response?.status) {
        // Only show the "Session Expired" dialog if we had a valid token at
        // the time of the request.  If authService._token is null we are still
        // initialising (or the token endpoint itself failed), so a redirect
        // would be premature and confusing.
        if (authService._token) {
            Swal.fire({
                title: "Session Expired",
                text: "Your session has expired. Please login again.",
                showCancelButton: false,
                confirmButtonColor: "#5052bb",
                confirmButtonText: "Yes"
            }).then(async function () {
                window.location.href = ApplicationPaths.LogOut;
            });;
        }
        // Always reject so callers still see the error.
        return Promise.reject(error);
    } else {
        return Promise.reject(error);
    }
})